function placeInfoBanner() {
  var $body = $('#body');
  if ($body.hasClass('homepage')) {
    if ($body.hasClass('saffireMobileSize') && $('.header #siteInfoBannerWidget').length > 0) {
      $('.header #siteInfoBannerWidget').appendTo('.section-tier-one');
    }
    if ($body.hasClass('saffireLargeSize') && $('.section-tier-one #siteInfoBannerWidget').length > 0) {
      $('.section-tier-one #siteInfoBannerWidget').appendTo('.header-bottom-inner');
    }  
  } else {
    if ($body.hasClass('saffireMobileSize') && $('.header #siteInfoBannerWidget').length > 0) {
      $('.header #siteInfoBannerWidget').insertAfter('.header');
    }
    if ($body.hasClass('saffireLargeSize') && $('.wrapper #siteInfoBannerWidget').length > 0) {
      $('.wrapper #siteInfoBannerWidget').appendTo('.header-bottom-inner');
    }    
  }
}


$(document).ready(function() {

  // prepend general message to header
  $('.generalmessage').prependTo('.header');

  // place siteInfoBanner
  placeInfoBanner(); 

  // Custom Header Search Functionality
  const nav = $('#mainNavigation');

  function handleSearch() {
    const input = $('.customSearch__input');
    const value = input.val();
    if (value !== '') { 
      $('.searchBox .inputFieldTextbox').val(value);
      $('.searchBox .searchSubmitButton').click();
    } else {
      return false;
    }
  }

  $('.customSearch').on('click keypress', function(e) {
    e.preventDefault();
    if (e.key === 'Enter' || e.type === 'click') {
      const wrapper = $('.customSearch-wrapper');
      if (!wrapper.hasClass('search-active')) {
        nav.fadeOut('fast');
        wrapper.fadeOut('fast', function() {
          wrapper.addClass('search-active');
          wrapper.fadeIn('fast', function() {
            $('.customSearch__input').focus();
          });
        })
      } else {
        handleSearch();
      }
    }
  });

  $('.customSearch__input').on('keypress', function(e) {
    if (e.key === 'Enter') {
      handleSearch();
    }
  });

  $('.customSearch__close').on('click keypress', function(e) {
    const wrapper = $('.customSearch-wrapper');
    wrapper.fadeOut('fast', function() {
      wrapper.removeClass('search-active');
      wrapper.fadeIn('fast');
      nav.fadeIn('fast');
    });
  });
  // ---

  // Footer Email Signup Text
  const $footer = $('.footer');
  $footer.find('.emailSignupText').remove();
  $footer.find('.emailSignup').prepend('<span>Sign up for mesquite rodeo’s<br> exciting deals & updates</span>');
  $footer.find('.emailSignup .inputFieldTextbox').val('')
  $footer.find('.emailSignup .inputFieldTextbox').attr('placeholder', 'EMAIL ADDRESS:');
  $footer.find('.emailSignup .emailSubmitButton').text('Subscribe');

  $footer.find('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffireFooter-logo.png`);

  $footer.find('.footerItems1 a').removeClass('button');

});


$(window).load(function() {
  $('.footer .footerItems1 a').removeClass('button');
  placeInfoBanner(); 
});

$(window).resize(function() {
  $('.footer .footerItems1 a').removeClass('button');

  placeInfoBanner(); 
})